import React, { useEffect, useState, type PropsWithChildren } from 'react';

const DELAY_MS = 1000;

type Props = {
  delayMs?: number;
};

/**
 * Displays children after delay
 */
const Delayed: React.FC<PropsWithChildren<Props>> = ({
  children,
  delayMs = DELAY_MS,
}) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsShown(true), delayMs);

    return () => clearTimeout(timeoutId);
  }, [delayMs]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isShown ? <>{children}</> : <div data-testid="delayed" />;
};

export default Delayed;
